import { Badge } from 'cpool-components/general/Badge';
import type { SchemaUserResolver_Get } from 'cpool-tables/backend-resolvers';
import { useTranslation } from 'react-i18next';
import { LuUserRoundCheck } from 'react-icons/lu';

import { IconBadge } from './IconBadge';
import LeadTrack from '~/components/LeadTrack';

type Props = {
    user: NonNullable<SchemaUserResolver_Get>;
};

export const LeadInfo: React.FC<Props> = ({ user }) => {
    const { t } = useTranslation();
    const { assignable, buckets } = user;

    const header = (
        <div className="flex items-center justify-between pb-2 border-b-2 border-white min-h-[38px]">
            <div className="flex items-center gap-4">
                <IconBadge icon={<LuUserRoundCheck />} className="text-blue-text bg-blue-cloud" />
                <h6 className="text-lg font-medium text-midnight">{t('DASHBOARD.LEAD_INFO.TITLE')}</h6>
            </div>
            <div className="ml-4">
                <LeadTrack />
            </div>
        </div>
    );

    const bucketList = (
        <div className="py-3">
            <p className="text-sm text-midnight">{t('DASHBOARD.LEAD_INFO.AVAILABLE_BUCKETS')}</p>
            <div className="flex flex-wrap">
                {buckets?.map((bucket) => {
                    return (
                        <Badge
                            key={bucket}
                            className="px-3 py-1 mr-2 mt-2 text-xs font-semibold rounded-full bg-surface-light xl:text-sm cursor-default"
                        >
                            {t(`leadTypes.${bucket}`)}
                        </Badge>
                    );
                })}
            </div>
        </div>
    );

    const content = () => {
        if (!assignable) {
            return (
                <div className="flex items-center justify-center h-[calc(100%-38px)]">
                    <p className="text-sm text-midnight">{t('DASHBOARD.LEAD_INFO.LEADTRACK_DISABLED')}</p>
                </div>
            );
        }

        if (buckets?.length > 0) {
            return bucketList;
        }

        return (
            <div className="flex items-center justify-center h-[calc(100%-38px)]">
                <p className="text-sm text-midnight">{t('DASHBOARD.LEAD_INFO.NO_BUCKETS')}</p>
            </div>
        );
    };

    return (
        <section className="py-2 px-5 h-full">
            {header}
            {content()}
        </section>
    );
};
